import { Disclaimers } from '@components/disclaimers'
import type { DisclaimersProps } from '@components/disclaimers/disclaimers'
import { Container } from '@components/layout/grid'
import { FOOTER_NAVIGATION_LINKS } from '@components/layout/navigation-links'
import { TEXT } from '@lib/utils/text'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'

import { FooterCta } from './footer-cta'
import { FooterLinks } from './footer-links'
import type { FooterLinksProps } from './footer-links'
import styles from './footer.module.scss'

/**
 * Global footer. Contains the {@link FooterCta} and {@link FooterLinks} components.
 */
export const Footer: FunctionComponent<FooterProps> = ({
    links = FOOTER_NAVIGATION_LINKS,
    disclaimers,
    showDisclaimersOnly = false,
}) => {
    const router = useRouter()
    const isFaqPage = router.asPath.startsWith('/faq')

    return (
        <footer
            data-testid='layout.footer'
            className={classNames(styles.footer)}
        >
            {!showDisclaimersOnly && (
                <Container>
                    <div className={styles.inner}>
                        <FooterCta />
                        {!!links && <FooterLinks links={links} />}
                    </div>
                </Container>
            )}

            <Disclaimers
                defaults={isFaqPage ? '' : TEXT.footer.defaultDisclaimer}
                {...disclaimers}
            />
        </footer>
    )
}

export default Footer

export interface FooterProps extends FooterLinksProps {
    disclaimers?: DisclaimersProps
    showDisclaimersOnly?: boolean
}
